import { render } from "./clock.vue?vue&type=template&id=0c79912c"
import script from "./clock.vue?vue&type=script&lang=js"
export * from "./clock.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__